<template>
    <footer class="footer-component" :style="style">
        <slot />
    </footer>
</template>

<script>
export default {
    name: 'FooterComponent',

    props: {
        height: {
            type: String,
            default: '60px'
        }
    },

    computed: {
        style() {
            const style = {}

            style.height = this.height

            return style
        }
    }
}
</script>

<style lang="scss">
.footer-component {
    display: flex;

    flex-shrink: 0;

    padding: 0 30px;
}
</style>
